const state = {
	job_positions_index: {
		data: [],
		links: {},
		meta: {},
	},
};

export default state;
